
import {
  CLIENT_ERROR,
  downloadFile,
  ellipsisString,
  formatDate,
  INTERNAL_SERVER_ERROR,
  INTERNET_ERROR,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import formatDateBasedTimezoneValue from "@/app/infrastructures/misc/common-library/FormatDateBasedTimezoneValue";
import { DispatchController } from "@/app/ui/controllers/DispatchController";
import {
  Dispatch,
  DispatchEntities,
  DispatchListRequest
} from "@/domain/entities/Dispatch";
import { Pagination } from "@/domain/entities/Pagination";
import moment from "moment";
import { Vue, Options } from "vue-class-component";
import { FlagsPermissionDispatch } from "../../../../../feature-flags/flags-dispatch";
import { Endpoints } from "@/app/infrastructures/misc/Endpoints";
import { onPrintDispatchManifest } from "./modules/manifest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ErrorMessageEntities } from "@/domain/entities/MainApp";
import EmptyList from "@/app/ui/components/empty-list/index.vue";

@Options({
  components: {
    // Add your components here
    EmptyList
  }
})
export default class DispatchList extends Vue {
  startDate: any = null;
  endDate: any = null;
  dispatchList = new DispatchEntities({
    pagination: new Pagination(1, 20),
    data: []
  });
  errorData = new ErrorMessageEntities();
  isError = false;
  errorCause = "";
  isLoading = false;

  get buttonActionError() {
    return {
      textColor: "white",
      title: this.$t("dispatch.reload"),
      iconLeft: "ics_o_reload"
    };
  }

  get isDetailAble() {
    return FlagsPermissionDispatch.permission_dispatch_detail_view.isEnabled();
  }
  // Add your class properties and methods here
  get getCurrentRoute() {
    return this.$route.meta.customName;
  }

  // search filter
  searchValue = "";
  onSearch(value: any) {
    this.searchValue = value;
    this.dispatchList.pagination.page = 1;
    this.onRequestFetchDispatchList();
  }
  clearSearch() {
    this.searchValue = "";
    this.dispatchList.pagination.page = 1;
    this.onRequestFetchDispatchList();
  }

  // date
  setPeriode(value: Array<any>) {
    this.startDate = value[0];
    this.endDate = value[1];
    this.dispatchList.pagination.page = 1;
    value[0] && value[1] && this.onRequestFetchDispatchList();
  }

  goToDispatch() {
    this.$router.push("/dispatch/update");
  }

  goToDetail(item: Dispatch) {
    if (item.dispatchStts !== 0) {
      this.$router.push(
        `/dispatch/${item.dispatchId}?params=${item.dispatchNo}&dispatchNo=${item.dispatchNo}`
      );
    }
  }

  async onRequestFetchDispatchList() {
    // get list
    try {
      this.isLoading = true;
      this.isError = false;
      const res = await DispatchController.getList(
        new DispatchListRequest({
          page: this.pagination.page,
          limit: this.pagination.limit,
          startDate: moment(this.startDate).format("YYYY-MM-DD"),
          endDate: moment(this.endDate).format("YYYY-MM-DD"),
          dispatchNo: this.searchValue,
          createdType: this.createdType === "all" ? "" : this.createdType
        })
      );
      this.onMappingDispatchList(res);
    } catch (error) {
      this.isLoading = false;
      this.isError = true;
      this.errorCause = parsingErrorResponse(error).type;
      this.errorData = parsingErrorResponse(error);
      if (
        this.errorData.type === INTERNAL_SERVER_ERROR ||
        this.errorData.type === CLIENT_ERROR
      ) {
        this.errorData.image = "error-token-ngen";
        this.errorData.title = this.$t("dispatch.errorSystem");
        this.errorData.message =
          this.$t("dispatch.errorSystemMessage");
      } else if (this.errorData.type === INTERNET_ERROR) {
        this.errorData.title = this.$t("dispatch.errorInternet");
        this.errorData.message =
          this.$t("dispatch.errorInternetMessage");
      }
    } finally {
      this.isLoading = false;
    }
  }

  onMappingDispatchList(res: DispatchEntities) {
    this.dispatchList = res;
  }

  // Pagination Table
  get pagination() {
    return this.dispatchList.pagination;
  }
  get dataTable() {
    return this.dispatchList.data;
  }
  // Table
  get columns() {
    return [
      {
        name: this.$t("dispatch.no"),
        styleHead: "w-10 text-left whitespace-no-wrap text-sm",
        render: (_item: any, index: number) => {
          return `<div class='text-left text-sm text-black-lp-300 flex justify-center break-words line-clamp-2'>${index +
            1 +
            this.pagination.limit * (this.pagination.page - 1)}</div>`;
        }
      },
      {
        name: this.$t("dispatch.noDispatch"),
        styleHead: "w-32 text-left whitespace-no-wrap text-sm",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-sm capitalize text-black-lp-300 break-words line-clamp-2">${item.dispatchNo}</div>`;
        }
      },
      {
        name: this.$t("dispatch.jumlahSttKoli"),
        styleHead: "w-20 text-left whitespace-no-wrap text-sm",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-sm text-left break-words line-clamp-2 text-black-lp-300">${item.dispatchStts} (${item.dispatchSttPieces} koli)</div>`;
        }
      },
      {
        name: this.$t("dispatch.totalWeight"),
        styleHead: "w-20 text-left whitespace-no-wrap text-sm",
        render: (item: any) => {
          const formattedWeight = Number(item.dispatchSttGrossWeights)
            .toFixed(2)
            .toString()
            .replace(".", ",");
          return `<div class='overflow-ellipsis line-clamp-1 text-sm text-black-lp-300'>${formattedWeight} kg</div>`;
        }
      },
      {
        name: this.$t("dispatch.createdAt"),
        styleHead: "w-32 text-left whitespace-no-wrap text-sm",
        render: (item: any) => {
          return `<span class="text-black-lp-300 text-sm">${formatDateBasedTimezoneValue(
            item.dispatchCreatedAt.replace("+07:00", ""),
            "DD MMMM YYYY, HH:mm"
          ) + " WIB"}
          
          </span>
          <div class='flex text-sm text-gray-lp-500 text-12px'>${ellipsisString(
            item.dispatchCreatedByName,
            20
          )}, ${item.dispatchCreatedByRole}</div>`;
        }
      },
      {
        name: this.$t("dispatch.courierShuttle"),
        styleHead: "w-32 text-left whitespace-no-wrap text-sm",
        render: (item: any) => {
          return !item.dispatchToDriverId && !item.dispatchToShuttleId
            ? "<div class='flex text-sm text-black-lp-300 text-sm'>-</div>"
            : `<span class="text-black-lp-300 text-sm">${
                item.dispatchToDriverId
                  ? `${item.dispatchToDriverId} - ${item.dispatchToDriverName}`
                  : `${item.dispatchToCityCode} - ${item.dispatchToShuttleName}`
              }
              </span>
              <div class='flex text-gray-lp-500 text-12px'>${
                item.dispatchToDriverId
                  ? item.dispatchToDriverPhone
                  : item.dispatchToHubName
              }</div>`;
        }
      },
      {
        name: this.$t("dispatch.atur"),
        key: "button_column",
        styleHead: "w-10 text-left",
        styleButton: (item: any, _: any) => {
          return {
            outline: true,
            icon: "option-gray",
            title: "",
            textColor: "black",
            color: "gray-lp-400",
            small: false,
            groupOptionsClass: "pickup-manifest-group-options",
            clickFunction: () => {
              true;
            },
            groupOptions: [
              {
                icon: "download-new-gray",
                label: this.$t("dispatch.downloadData"),
                sizeIcon: "18px",
                clickFunction: () => {
                  downloadFile(
                    `${Endpoints.baseUrl}/hydra/v1/dispatch/${item.dispatchId}/xlsx`,
                    `dispatch_${item.dispatchId}_${moment().format(
                      "YYYY-MM-DD"
                    )}`,
                    `.xlsx`,
                    true
                  );
                }
              },
              {
                icon: "printer",
                label: this.$t("dispatch.printPdf"),
                sizeIcon: "18px",
                clickFunction: () => {
                  this.generateManifestDist(item.dispatchId);
                }
              }
            ]
          };
        }
      },
      {
        name: "",
        styleHead: "w-16 text-left whitespace-no-wrap text-sm",
        render: (_item: any) => {
          return ``;
        }
      }
    ];
  }

  createdType = "";
  get createdTypeList() {
    const res = [
      { name: this.$t("dispatch.filterCreatedBy"), value: "" },
      {
        name: this.$t("dispatch.all"),
        value: "all"
      },
      {
        name: this.$t("dispatch.checker"),
        value: "konsol_checker "
      },
      {
        name: this.$t("dispatch.shuttle"),
        value: "konsol_shuttle"
      }
    ];
    return res;
  }

  isOpenSelectCreatedType = false;
  onOpenSelectCreatedType() {
    this.isOpenSelectCreatedType = true;
  }

  onCloseSelectCreatedType() {
    this.isOpenSelectCreatedType = false;
  }

  onSelectCreatedType(name: string, value: string) {
    this.dispatchList.pagination.page = 1;
    this.createdType = value;
    this.onRequestFetchDispatchList();
  }

  async generateManifestDist(id: number) {
    try {
      MainAppController.showLoading();
      const detailData: Dispatch = await DispatchController.getDetail(id);
      onPrintDispatchManifest(detailData);
    } catch (e) {
      MainAppController.showErrorMessage(parsingErrorResponse(e));
    } finally {
      MainAppController.closeLoading();
    }
  }
}
